import React from "react";
import * as Accordion from "@radix-ui/react-accordion";
import cx from "classnames";
import { ArrowDown } from "components/icons/ArrowDown";

export const SearchCollapse = ({ title }: { title: string }) => {
  return (
    <Accordion.Trigger asChild>
      <button className="t-bg-surface-lighter-grey t-px-3 t-py-2 all:unset t-w-full t-flex t-justify-between t-items-center t-group t-sticky t-top-0 t-z-[100] t-flex-[0_0_auto]">
        <span className="t-text-caption t-uppercase">{title}</span>
        <span className="group-data-[state=open]:t-rotate-180 t-transform t-transition-transform">
          <button className="all:unset">
            <ArrowDown />
          </button>
        </span>
      </button>
    </Accordion.Trigger>
  );
};

export const ChatFilterAccordion = ({
  title,
  defaultOpen = true,
  children,
  contentId,
  isEmpty = false,
  takesFullHeight,
}: {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
  contentId: string;
  isEmpty?: boolean;
  takesFullHeight?: boolean;
}) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);

  return (
    <div className={cx(takesFullHeight && isOpen ? "t-h-full" : "t-h-auto")}>
      <Accordion.Root
        type="multiple"
        defaultValue={defaultOpen ? [title.toUpperCase()] : []}
        className={cx("t-flex t-flex-col", {
          "t-h-auto": !isOpen || isEmpty,
          "t-h-full": isOpen && !isEmpty,
        })}
        onValueChange={(value) => {
          setIsOpen(value.includes(title.toUpperCase()));
        }}
      >
        <Accordion.Item
          value={title.toUpperCase()}
          className={cx("t-flex t-flex-col t-mb-1", {
            "t-h-auto": !isOpen || isEmpty,
            "t-h-full": isOpen && !isEmpty,
          })}
        >
          <SearchCollapse title={title} />
          <Accordion.Content
            forceMount
            id={contentId}
            className={cx("t-overflow-y-auto t-w-full", {
              "t-block": isOpen,
              "t-hidden": !isOpen,
              "t-h-auto": isEmpty,
              "t-flex-1": !isEmpty && isOpen,
            })}
          >
            {children}
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  );
};
